import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createContext, useContext, useEffect, useState } from "react";
import { AuthProvider } from "@descope/react-sdk";
import { Alert, AlertDescription, AlertTitle } from "@nxt-shared/ui/components/Alert";
import { GlobalLoading } from "./GlobalLoading.js";
import { SharedSessionRestore } from "./SharedSessionRestore.js";
import { environmentConfigUrl, loadEnvironmentConfig } from "./utils/environmentConfig.js";
import { globalComponents } from "./i18n.js";
// One request per page, shared by every provider on it (the widget bundle mounts two elements).
let pendingConfig;
function environmentConfig() {
    pendingConfig ??= loadEnvironmentConfig(environmentConfigUrl(import.meta.url)).catch((error) => {
        pendingConfig = undefined;
        throw error;
    });
    return pendingConfig;
}
export function PlatformBootError({ message }) {
    const t = globalComponents.useT();
    return _jsx("div", { className: "flex h-dvh items-center justify-center p-6", children: _jsxs(Alert, { variant: "danger", className: "max-w-lg", children: [_jsx(AlertTitle, { children: t("signIn.couldNotStart") }), _jsxs(AlertDescription, { children: [_jsx("p", { children: t("signIn.body") }), message && (_jsxs("details", { className: "mt-2", children: [_jsx("summary", { children: t("errorBoundary.details") }), _jsx("pre", { className: "whitespace-pre-wrap", children: message })] }))] })] }) });
}
const EnvironmentConfigContext = createContext(undefined);
/** The environment configuration `PlatformAuthProvider` loaded; undefined outside it. */
export function useEnvironmentConfig() {
    return useContext(EnvironmentConfigContext);
}
export function platformAuthView(state, props) {
    if (state.status === "loading")
        return _jsx(_Fragment, { children: props.loadingFallback ?? _jsx(GlobalLoading, {}) });
    if (state.status === "error")
        return _jsx(_Fragment, { children: props.errorFallback?.(state.message) ?? _jsx(PlatformBootError, { message: state.message }) });
    return _jsx(EnvironmentConfigContext.Provider, { value: state.config, children: _jsx(AuthProvider, { projectId: state.config.descopeProjectId, baseUrl: state.config.authBaseUrl, autoRefresh: true, children: props.restoreSharedSession
                ? _jsx(SharedSessionRestore, { fallback: props.loadingFallback, children: props.children })
                : props.children }) });
}
/** Descope's AuthProvider, configured from the environment that served this code (`/management/api/config`). */
export function PlatformAuthProvider(props) {
    const [state, setState] = useState({ status: "loading" });
    useEffect(() => {
        environmentConfig()
            .then((config) => setState({ status: "loaded", config }))
            .catch((error) => {
            console.error("Error loading environment config:", error);
            setState({ status: "error", message: error instanceof Error ? error.message : undefined });
        });
    }, []);
    return platformAuthView(state, props);
}
//# sourceMappingURL=PlatformAuthProvider.js.map